const SQFT_DIVIDER = 0.092903

const sqftToMeters = value => Math.round(value * SQFT_DIVIDER * 100) / 100

export default sqftToMeters
